const ApaItuAI: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🧠 Apa Itu Artificial Intelligence? Penjelasan Singkat untuk Pemula</h2>

            <p className="mb-4">
                <strong>Artificial Intelligence (AI)</strong> atau Kecerdasan Buatan adalah kemampuan mesin atau komputer untuk melakukan tugas-tugas yang biasanya memerlukan kecerdasan manusia. Dengan AI, mesin bisa <em>&quot;berpikir&quot;</em>, <em>belajar dari pengalaman</em>, <em>memahami data</em>, dan bahkan <em>membuat keputusan</em> secara mandiri.
            </p>

            <p className="mb-4">
                AI memungkinkan komputer untuk mengenali suara, memahami gambar, menerjemahkan bahasa, hingga mengemudikan kendaraan. Tujuannya adalah membuat mesin menjadi &quot;pintar&quot; dan mampu menyelesaikan masalah kompleks seperti manusia.
            </p>

            <h3 className="text-md font-semibold mb-2">🔍 Contoh AI di Kehidupan Sehari-Hari</h3>
            <p className="mb-4">
                Kamu mungkin sudah sering menggunakan AI tanpa sadar. Berikut beberapa contoh penerapannya:
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>🗣️ <strong>Asisten Virtual</strong> seperti Siri, Alexa, atau Google Assistant yang bisa menjawab pertanyaanmu atau mengatur jadwal.</li>
                <li>🎬 <strong>Rekomendasi Film</strong> di Netflix, YouTube, atau Spotify berdasarkan preferensi tontonan atau lagu favoritmu.</li>
                <li>📷 <strong>Filter Kamera dan Pengenalan Wajah</strong> di media sosial seperti Instagram dan TikTok.</li>
                <li>🚗 <strong>Mobil Otonom</strong> seperti Tesla yang dapat mengemudi sendiri dengan bantuan sensor dan pemrosesan AI.</li>
                <li>📩 <strong>Filter Spam</strong> di email yang menyaring pesan mencurigakan secara otomatis.</li>
            </ul>

            <h3 className="text-md font-semibold mb-2">📚 Perbedaan AI, Machine Learning, dan Deep Learning</h3>
            <p className="mb-4">
                Banyak orang masih bingung membedakan ketiganya. Berikut penjelasan sederhananya:
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>
                    <strong>🤖 Artificial Intelligence (AI):</strong><br />
                    Merupakan <em>konsep umum</em> tentang mesin atau sistem yang bisa melakukan tugas yang membutuhkan kecerdasan. Contohnya: bermain catur, mengenali suara, atau membaca tulisan tangan.
                </li>
                <li>
                    <strong>📈 Machine Learning (ML):</strong><br />
                    Adalah <em>sub-bidang dari AI</em> yang fokus pada kemampuan mesin untuk <strong>belajar dari data</strong>. Dengan ML, sistem tidak perlu diprogram secara eksplisit, melainkan belajar dari pola yang ada. Contoh: mengenali spam berdasarkan email sebelumnya.
                </li>
                <li>
                    <strong>🧠 Deep Learning:</strong><br />
                    Merupakan <em>bagian dari Machine Learning</em> yang menggunakan <strong>neural network</strong>, model komputasi yang meniru cara kerja otak manusia. Deep Learning sangat kuat untuk tugas-tugas seperti pengenalan wajah, suara, dan bahkan membuat gambar dari nol.
                </li>
            </ul>

            <h3 className="text-md font-semibold mb-2">🎓 Mengapa Penting Memahami AI?</h3>
            <p className="mb-4">
                Di era digital, AI ada di mana-mana. Dari ponsel, layanan kesehatan, pendidikan, hingga industri kreatif, semuanya mulai memanfaatkan teknologi ini. Dengan memahami AI, kamu tidak hanya jadi pengguna teknologi, tapi bisa juga jadi <strong>pencipta solusi masa depan</strong>.
            </p>

            <p className="text-gray-700">
                Jadi, jangan takut belajar AI! Meski awalnya tampak rumit, konsep-konsep dasarnya bisa kamu pahami dengan latihan dan proyek kecil. Siapa tahu, kamu bisa menciptakan AI-mu sendiri di masa depan! 🚀
            </p>

        </div>
    )
}
export default ApaItuAI
